import {fromJS} from 'immutable'
import uniqueId from 'lodash/uniqueId'

/**
 * Actions
 */
const SHOW_TOAST = 'expii/toast/SHOW_TOAST'
const HIDE_TOAST = 'expii/toast/HIDE_TOAST'


/**
 * Reducer
 */
const defaultModalState = fromJS({
  toasts: [
    //toastProps: {}
  ]
})

export default function reducer(state = defaultModalState, action = {}) {
  switch (action.type) {
  case SHOW_TOAST:
    const {toastProps} = action
    toastProps.id = uniqueId('toast')
    return state.withMutations(s => {
      s = s.set('toasts', s.get('toasts').push(fromJS(toastProps)))
      return s
    })
  case HIDE_TOAST:
    const {id} = action
    return state.withMutations(s => {
      let index = 0
      s.get('toasts').forEach((value, i) => {
        if (value.get('id') === id) {
          index = i
          return false
        }
      })
      s = s.deleteIn(['toasts', index])
      return s
    })
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function showToast(toastProps) {
  return { type: SHOW_TOAST, toastProps }
}

export function hideToast(id) {
  return { type: HIDE_TOAST, id }
}

/**
 * Selectors
 */
export const selectToasts = (state) => {
  const domain = state.get('toast')
  return {
    toasts: domain.get('toasts')
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/toast.js